import api from "./api";

const subscriptionService = {
  // Get all available plans
  getPlans: async () => {
    const response = await api.get("/subscriptions/plans/");
    return response.data;
  },

  // Get current user's subscription and usage
  getSubscription: async () => {
    const response = await api.get("/subscriptions/subscription/");
    return response.data;
  },

  // Create a Razorpay order
  createOrder: async (planId, billingCycle) => {
    const response = await api.post("/subscriptions/create-order/", {
      plan_id: planId,
      billing_cycle: billingCycle,
    });
    return response.data;
  },

  // Verify payment and activate subscription
  verifyPayment: async (paymentData) => {
    const response = await api.post("/subscriptions/verify-payment/", paymentData);
    return response.data;
  },

  // Cancel subscription
  cancelSubscription: async () => {
    const response = await api.post("/subscriptions/subscription/cancel/");
    return response.data;
  },

  // Get payment history
  getPaymentHistory: async () => {
    const response = await api.get("/subscriptions/payments/");
    return response.data;
  },

  // Check feature access
  checkFeatureAccess: async (feature) => {
    const response = await api.get(`/subscriptions/check-access/?feature=${feature}`);
    return response.data;
  },

  // Increment AI usage
  incrementUsage: async (featureType) => {
    const response = await api.post("/subscriptions/increment-usage/", {
      feature_type: featureType,
    });
    return response.data;
  },
};

export default subscriptionService;
